import mountFilepicker from './filepicker';
import mountSelect from './selector';

$(document).on('nested:fieldAdded', (event) => {
  if (event.field.find('.with-select2').length > 0) {
    event.field.find('.with-select2').each((_, element) => mountSelect(element));
  }
  if (event.field.find('.filepicker').length > 0) {
    event.field.find('.filepicker').each(mountFilepicker);
  }
});
